import { render, staticRenderFns } from "./faq-list-mo.vue?vue&type=template&id=2ce8fb6e&scoped=true&"
import script from "./faq-list-mo.vue?vue&type=script&lang=js&"
export * from "./faq-list-mo.vue?vue&type=script&lang=js&"
import style0 from "./faq-list-mo.vue?vue&type=style&index=0&id=2ce8fb6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce8fb6e",
  null
  
)

export default component.exports